import React, { useState } from "react";
import { connect } from "react-redux";
import { billing as actions } from "actions";
import {
  Elements,
  useStripe,
  useElements,
  CardNumberElement,
  CardExpiryElement,
  CardCvcElement,
} from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";

import { createOptions } from "./Card_Element";
import SummaryDetails from "../User_Account/Subscription/Summary_Details";
import StripeElementWrapper from "components/styled/Stripe_Element_Wrapper";
import PoweredByStripeLogo from "components/elements/Powered_By_Stripe";
import Intl from "components/Intl";
import { returnStripePublishable } from "functions/hostname";

const stripePromise = loadStripe(returnStripePublishable());

function SetupSubContent({
  user,
  messages,
  locale,
  createCustomerAndSubscription,
  createSubscriptionExistingCustomer,
  finalizeSubscriptionAfterSCA,
}) {
  const stripe = useStripe();
  const elements = useElements();

  const [validation, setValidation] = useState({ error: false, message: "" });
  const [cardInputsCompleted, setCardInputComplete] = useState({
    cardNumber: false,
    cardExpiry: false,
    cardCVC: false,
  });

  function handleChange({ error, complete }, inputName) {
    if (error) {
      setValidation({ error: true, message: error.message });
      setCardInputComplete((prev) => ({ ...prev, [inputName]: false }));
    } else {
      setValidation({ error: false, message: "" });
      setCardInputComplete((prev) => ({ ...prev, [inputName]: complete }));
    }
  }

  async function submit(ev) {
    ev.preventDefault();

    if (!stripe || !elements) return;

    const cardNumberElement = elements.getElement(CardNumberElement);
    
    // 1. Luodaan Payment Method
    const { paymentMethod, error } = await stripe.createPaymentMethod({
      type: "card",
      card: cardNumberElement,
      billing_details: { email: user.email },
    });

    if (error) {
      setValidation({ error: true, message: error.message });
      return;
    }

    try {
      let subscription;

      // 2. Luodaan tilaus (Välitetään stripe-instanssi SCA:ta varten)
      if (!user.stripeInfo?.customerId) {
        subscription = await createCustomerAndSubscription(paymentMethod, stripe);
      } else {
        subscription = await createSubscriptionExistingCustomer(paymentMethod, stripe);
      }

      // 3. Viimeistellään tilaus backendissä (SCA-synkronointi)
      if (subscription && subscription.id) {
        await finalizeSubscriptionAfterSCA(subscription.id, () => {
          this.props.history.push("/userhome")// Tai mihin haluat käyttäjän ohjata
        });
      }
    } catch (e) {
      setValidation({ error: true, message: "Subscription creation failed." });
    }
  }

  const isFormInvalid = validation.error || Object.values(cardInputsCompleted).some((v) => !v);

  return (
    <div className="checkout notification" style={{ padding: 8 }}>
      <div className="columns is-2 is-variable is-flex-desktop is-mobile is-multiline">
        <div className="column is-6-desktop is-12-mobile">
          <div className="box">
            <div className="level is-mobile is-marginless">
              <div className="level-left">
                <p className="title is-5 has-text-dark">
                  {messages.labels.enterCardDetails[locale]}
                </p>
              </div>
              <div className="level-right">
                <PoweredByStripeLogo />
              </div>
            </div>

            <label className="label is-small">
              {messages.labels.cardNumber[locale]}
              <StripeElementWrapper>
                <CardNumberElement onChange={(e) => handleChange(e, "cardNumber")} options={createOptions()} />
              </StripeElementWrapper>
            </label>

            <label className="label is-small">
              {messages.labels.cardExpiry[locale]}
              <StripeElementWrapper>
                <CardExpiryElement onChange={(e) => handleChange(e, "cardExpiry")} options={createOptions()} />
              </StripeElementWrapper>
            </label>

            <label className="label is-small">
              {messages.labels.cardCVC[locale]}
              <StripeElementWrapper>
                <CardCvcElement onChange={(e) => handleChange(e, "cardCVC")} options={createOptions()} />
              </StripeElementWrapper>
            </label>

            {validation.error && <p className="is-danger help">{validation.message}</p>}
          </div>
        </div>

        <div className="column is-6-desktop is-12-mobile">
          <div className="box" style={{ height: "100%" }}>
            <div className="buttons">
                <button
                      className="button is-link is-fullwidth"
                      onClick={submit}
                      disabled={
                        validation.error ||
                        Object.values(cardInputsCompleted).some((v) => v === false)
                      }
                    >
                       <Intl
                        message
                        path={"components.buttons.stripe.setupSubscription"} date={undefined} number={undefined} dateProps={undefined} numberProps={undefined} messageProps={undefined}                      />
                    </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

function SetupSub(props) {
  return (
    <Elements stripe={stripePromise}>
      <SetupSubContent {...props} />
      <SummaryDetails />
    </Elements>
  );
}

export default connect(null, actions)(SetupSub);